import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const FooterContainer = styled.footer`
  background: var(--gray-800);
  color: white;
  padding: 3rem 0;
`;

const FooterContent = styled.div`
  max-width: 64rem;
  margin: 0 auto;
  padding: 0 1rem;
`;

const FooterGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 2rem;
  margin-bottom: 2rem;

  @media (min-width: 768px) {
    grid-template-columns: repeat(3, 1fr);
  }
`;

const FooterSection = styled.div`
  h3 {
    font-size: 1.25rem;
    font-weight: 600;
    margin-bottom: 1rem;
  }

  p {
    margin-bottom: 0.5rem;
    color: var(--gray-300);
  }
`;

const FooterDivider = styled.div`
  border-top: 1px solid var(--gray-700);
  margin-top: 2rem;
  padding-top: 2rem;
  text-align: center;
`;

const SiteIndex = styled.div`
  margin-bottom: 1rem;
`;

const SiteIndexNav = styled.nav`
  ul {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 1rem;
    margin: 0;
    padding: 0;
    list-style: none;
  }
`;

const SiteIndexLink = styled(Link)`
  font-size: 0.875rem;
  color: var(--gray-300);
  text-decoration: none;
  transition: color 0.3s;

  &:hover {
    color: white;
  }
`;

const Copyright = styled.p`
  color: var(--gray-400);
  font-size: 0.875rem;
`;

const Footer: React.FC = () => {
  return (
    <FooterContainer>
      <FooterContent>
        <FooterGrid>
          <FooterSection>
            <h3>Ota Tofu</h3>
            <p>America's oldest tofu manufacturer, proudly serving the Northwest since 1911.</p>
          </FooterSection>

          <FooterSection>
            <h3>Hours & Location</h3>
            <p>812 SE Stark St</p>
            <p>Portland, OR 97214</p>
            <p>Monday-Saturday: 8am-5pm</p>
            <p>Sunday: Closed</p>
          </FooterSection>

          <FooterSection>
            <h3>Contact Us</h3>
            <p>Phone: (503) 232-8947</p>
            <p>Email: info@otapdx.com</p>
          </FooterSection>
        </FooterGrid>

        <FooterDivider>
          <SiteIndex>
            <SiteIndexNav>
              <ul>
                <li><SiteIndexLink to="/">Home</SiteIndexLink></li>
                <li><SiteIndexLink to="/about">About</SiteIndexLink></li>
                <li><SiteIndexLink to="/contact">Contact</SiteIndexLink></li>
                <li><SiteIndexLink to="https://tofumerch.com" target="_blank" rel="noopener noreferrer">Merch Store</SiteIndexLink></li>
              </ul>
            </SiteIndexNav>
          </SiteIndex>
          <Copyright>&copy; 2024 Ota Tofu. All rights reserved.</Copyright>
        </FooterDivider>
      </FooterContent>
    </FooterContainer>
  );
};

export default Footer; 
 
 